<template>
  <el-card shadow="never">
    <p class="text-base leading-6 text-gray-950 lg:mx-0 mx-2">
      <span>
        {{ $t('common.inquiryNote.titleComplete') }}
      </span>
      <br />
      <span>
        {{ $t('common.inquiryNote.note1-1') }}
      </span>
      <br />
      <span>
        {{ $t('common.inquiryNote.note1-2') }}
      </span>
      <br />
      <span>
        {{ $t('common.inquiryNote.note1-3') }}
      </span>
      <br />
      <span>
        {{ $t('common.inquiryNote.note1-4') }}
      </span>
      <br />
      <span>
        {{
          $t('common.inquiryNote.note1-5', {
            phoneAndTime: `${Utils.helper.formatPhoneNumber(shop.phone_number)} ${shop.business_hour}`,
          })
        }}
      </span>
    </p>
    <div v-html="contentFooter2"></div>
  </el-card>
</template>

<script>
import { HtmlService } from '@/services'
export default {
  data() {
    return {
      contentFooter2: '',
    }
  },
  mounted() {
    this.fetchFooter2Content()
  },
  computed: {
    shop() {
      return this.$store.getters['auth/shop']
    },
  },
  methods: {
    async fetchFooter2Content() {
      const res = await HtmlService.getHtmlContent(this.Constants.SHOP_CONFIG.FOOTER2)
      this.contentFooter2 = res.data
    },
  },
}
</script>

<style></style>
